// Generated by CoffeeScript 2.7.0
var Pagination;

import Popover from './popover.js';

import DropdownSelect from './dropdown_select.js';

export default Pagination = class Pagination {
  static init() {
    return _.each(DomMaster.findAll('.js-pagination'), (element) => {
      return new this(element);
    });
  }

  constructor(element1) {
    var dropdown_select, popover;
    this.element = element1;
    if (!this.element.isPresent()) {
      return;
    }
    popover = this.element.find('.popover');
    if (popover.isPresent()) {
      new Popover(popover.node, {
        stop: true
      });
    }
    dropdown_select = this.element.find('.dropdown-select');
    if (dropdown_select.isPresent()) {
      new DropdownSelect(dropdown_select.node);
    }
  }

};
